import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {RoutesEnum} from '../../core/services/navigation/routes.enum';
import {AuthGuardService} from '../../core/services/security/auth-guard.service';
import {BoxComponent} from './box.component';
import {BoxesRoutesEnum} from './services/navigation/boxes-routes.enum';
import {BoxesListComponent} from './boxes-list/boxes-list.component';
import {BatchCreateBoxComponent} from './batch-create-box/batch-create-box.component';

const routes: Routes = [
  {
    path: RoutesEnum.BOXES,
    component: BoxComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: BoxesRoutesEnum.LIST,
        component: BoxesListComponent,
      },
      {
        path: BoxesRoutesEnum.BATCH_CREATE,
        component: BatchCreateBoxComponent,
      }
    ],
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
  exports: [RouterModule],
})
export class BoxRoutingModule {
}
